import {
  ArrowDownTrayIcon,
  Button,
  Flex,
  IconMenu,
  Image,
  TableCellsIcon,
  Text,
  toaster,
} from 'components'
import { useWorkspace } from 'components/providers'
import { IntegrationTool } from 'types'
import { pushCRMLeads, useDisclosure } from 'utils'
import {
  exportSessions,
  integrationLogoRenderer,
  useActiveWorkspaceIntegration,
  useEvent,
  useOnTheGo,
} from '../../utils'

export default function SessionExportButton() {
  const { workspace } = useWorkspace()
  const { event } = useEvent()
  const { sessionCount: otgSessionCount } = useOnTheGo()
  const sessionCount = event ? event?.sessionCount : otgSessionCount
  const disclosure = useDisclosure()
  const crmIntegration = useActiveWorkspaceIntegration('CRM')

  function handleCsvExport() {
    const promise = exportSessions({ event: event ?? undefined, workspaceId: workspace?.id ?? '' })
    handleLoading(promise, `Exporting ${sessionCount} sessions as CSV`)
  }

  async function handleExportToCMS(tool: IntegrationTool) {
    if (!event) return
    const promise = pushCRMLeads({ eventId: event.id, integrationTool: tool })
    handleLoading(promise, `Exporting sessions to ${tool}`)
  }

  function handleLoading(promise: Promise<any>, description: string) {
    disclosure.onClose()
    toaster.promise(promise, {
      loading: { title: 'Exporting', description },
      success: { title: 'Export Successful', description },
      error: { title: 'Export Failed', description },
    })
  }

  const options = [
    {
      type: 'custom',
      label: (
        <Button onClick={handleCsvExport} variant="ghost" my={2} w="100%" justify="space-between">
          <Flex {...menuOptionProps}>
            <TableCellsIcon />
            <Text textStyle="bodySmall">Export as CSV</Text>
          </Flex>
        </Button>
      ),
    } as const,
  ]
  if (crmIntegration?.mapping)
    options.push({
      type: 'custom',
      label: (
        <Button onClick={() => handleExportToCMS(crmIntegration.tool.name)} variant="ghost">
          <Flex {...menuOptionProps}>
            <Image
              src={integrationLogoRenderer(crmIntegration.tool.name)}
              w="25px"
              aria-label="integration-logo"
            />
            <Flex direction="column" align="start">
              <Text textStyle="bodySmall">Export to {crmIntegration.tool.name}</Text>
              {event?.dataIntegration?.lastPushed && (
                <Text textStyle="bodyXSmall" fontWeight="normal" opacity={0.5}>
                  Last exported: {new Date(event.dataIntegration.lastPushed).toLocaleString()}
                </Text>
              )}
            </Flex>
          </Flex>
        </Button>
      ),
    })

  if (!workspace) return null

  return (
    <IconMenu
      icon={<ArrowDownTrayIcon />}
      menuProps={{
        colorMode: 'light',
        disabled: !sessionCount,
        menuProps: {
          positioning: { placement: 'bottom-end' },
        },
        options: options,
      }}
      tooltipContent="Export"
    />
  )
}

const menuOptionProps = {
  w: '100%',
  gap: 2,
  align: 'center',
  borderRadius: '10px',
}
